( function ( $ ) {

	MP.faq = function(){


		var btns = document.querySelectorAll( '.faq-q' );
		var active;
			
		btns.length && [].forEach.call( btns, function( btn ){

			var $a = $( btn.parentNode.parentNode.querySelector('.faq-item-answer' ) ),
				flag = true;


			btn.addEventListener('click',function(e){

				e.preventDefault();
				flag = !flag;

				// Close current open section
				if (active && active !== this) {
					active.click();
				}

				active = !flag ? this : false;

				var expanded = $(this).attr('aria-expanded') === 'true';

				$(this).attr('aria-expanded', (!expanded).toString() );
				$(this).toggleClass('is-on');

				var effect = $a.css('display') === 'none' ? 'Down' : 'Up';

				$a.attr('aria-hidden' , flag );

				$a['slide' + effect](200);

			});

		});

	};

}) ( window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/m-faq.js